import { Banner } from "@/components/shared/banner";
import { useRoute } from "@/components/shared/router";

import { Button } from "@/components/ui";

export function ClaimRewardBanner() {
  const { push } = useRoute();

  return (
    <Banner
      type="my-reward"
      title="Claim your reward!"
      description="Explore your exclusive offers: check out eligible promo codes for our services."
      action={
        <Button
          variant="tertiary"
          color="CTA"
          rounded="full"
          size={{ sm: "sm", md: "md" }}
          children="See my reward"
          onClick={() => {
            push({ pageKey: "rewards" });
          }}
        />
      }
    />
  );
}
